module.exports = __webpack_public_path__ + "media/evolve/assets/icons/planned/brush-a35126db2b73dec2d601952d3ba47339.svg";